import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserInformationContext, InfoModalContext, C4FStatusContext } from "../main/App";
import { ButtonGroup, Button, Row, Col } from 'react-bootstrap';
import '../css/general.css';
import config from "../etc/config.json";
import { Map, ZoomControl } from "pigeon-maps";
import C4FDetailedProfile from "./C4FDetailedProfile";
import C4FSimpleTable from "../common/C4FSimpleTable";
import { getJersey } from "../race/C4FLeaderJerseys";
import moment from 'moment';
import { currentISODate } from "../common/Helpers";
import C4FPrizeMoney from "../race/C4FPrizeMoney";


function CalendarSingleRace(props) {
  const { userInformation } = useContext(UserInformationContext);
  const { handleBackendRequest } = useContext(C4FStatusContext);
  const { showRiderInfo, showTeamInfo } = useContext(InfoModalContext);

  const [tab, setTab] = useState('Stages');
  const [race, setRace] = useState(null);
  const [selectedStage, setSelectedStage] = useState(null);
  const [profiles, setProfiles] = useState([]);
  const [weatherForecasts, setWeatherForecasts] = useState([]);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [selectedRaceEditionId, setSelectedRaceEditionId] = useState('selectedRaceEditionId' in props ? props.selectedRaceEditionId : null);
  const [raceEditionResults, setRaceEditionResults] = useState([]);
  const [selectedStageNumber, setSelectedStageNumber] = useState(1);
  const [racePalmares, setRacePalmares] = useState([]);
  const [raceTeamPalmares, setRaceTeamPalmares] = useState([]);
  const [raceRiderPalmares, setRaceRiderPalmares] = useState([]);
  const [palmaresTypeFilterName, setPalmaresTypeFilterName] = useState(null);
  const [palmaresTypeSorting, setPalmaresTypeSorting] = useState("stages");
  const [palmaresTypeFilter, setPalmaresTypeFilter] = useState([]);
  const navigate = useNavigate();

  function loadRace() {
    handleBackendRequest('GET', '/race/' + props.raceId, null, props.raceType && props.raceType === 'editor' ? { context: 'editor' } : null,
      function (race) {
        setRace(race);
        handleOnClickStages(race.stages[0], race);
      });
  }

  function loadPreviousWinners() {
    handleBackendRequest('GET', '/race/' + props.raceId, null, { context: 'history', raceType: props.raceType ? props.raceType : 'unknown' },
      function (history) {
        processPalmares(history)
        if (race.duration > 1) handlePalmaresTypeFilter('StageRaceWin');
        else handlePalmaresTypeFilter('StageWin');
      },
      true,
      function () { processPalmares([]); });
  }

  function processPalmares(palmares) {
    let allRiders = new Set();
    let allTeams = new Set();
    palmares.map(p => {
      allRiders.add(p.riderId);
      allTeams.add(p.teamId);
      return;
    });

    let riderPalmares = Array.from(allRiders).map(id => ({
      riderId: id,
      riderName: palmares.find(p => p.riderId === id).riderName,
      teamName: palmares.find(p => p.riderId === id).teamName,
      teamId: palmares.find(p => p.riderId === id).teamId,
      stages: palmares.filter(p => p.riderId === id && p.type === 'StageWin').length,
      tours: palmares.filter(p => p.riderId === id && p.type === 'StageRaceWin').length,
      sprintJerseys: palmares.filter(p => p.riderId === id && p.type === 'SprintJersey').length,
      mountainJerseys: palmares.filter(p => p.riderId === id && p.type === 'MountainJersey').length,
      youthJerseys: palmares.filter(p => p.riderId === id && p.type === 'YouthJersey').length,
      teamClassifications: palmares.filter(p => p.riderId === id && p.type === 'TeamClassification').length
    }));

    let teamPalmares = Array.from(allTeams).map(id => ({
      teamId: id,
      teamName: palmares.find(p => p.teamId === id).teamName,
      stages: palmares.filter(p => p.teamId === id && ['StageWin', 'TeamTimeTrial'].includes(p.type)).length,
      tours: palmares.filter(p => p.teamId === id && p.type === 'StageRaceWin').length,
      sprintJerseys: palmares.filter(p => p.teamId === id && p.type === 'SprintJersey').length,
      mountainJerseys: palmares.filter(p => p.teamId === id && p.type === 'MountainJersey').length,
      youthJerseys: palmares.filter(p => p.teamId === id && p.type === 'YouthJersey').length,
      teamClassifications: palmares.filter(p => p.teamId === id && p.type === 'TeamClassification').length,
      teamTimeTrial: palmares.filter(p => p.teamId === id && p.type === 'TeamTimeTrial').length
    }));

    setRacePalmares(palmares);
    setRaceTeamPalmares(teamPalmares);
    setRaceRiderPalmares(riderPalmares);
  }

  function handlePalmaresTypeFilter(filter) {
    setPalmaresTypeFilterName(filter);
    setPalmaresTypeFilter([{
      columnName: 'type',
      type: 'text',
      value: filter,
      regex: filter,
      valid: true
    }]);
    if (filter === "StageWin") {
      setPalmaresTypeSorting("stages");
    }
    else if (filter === "StageRaceWin") {
      setPalmaresTypeSorting("tours");
    }
    else if (filter === "SprintJersey") {
      setPalmaresTypeSorting("sprintJerseys");
    }
    else if (filter === "MountainJersey") {
      setPalmaresTypeSorting("mountainJerseys");
    }
    else if (filter === "YouthJersey") {
      setPalmaresTypeSorting("youthJerseys");
    }
    else if (filter === "TeamClassification") {
      setPalmaresTypeSorting("teamClassifications");
    }
  }

  function handleProfileResponse(profile, race, stage) {
    setSelectedStage(race.stages[stage.number - 1]);
    setSelectedProfile(profile);
    setSelectedStageNumber(stage.number);
    handleSetSelectedRaceEditionId(selectedRaceEditionId);
    // put in cache
    let profilesLocal = profiles.slice();
    profilesLocal.push(profile);
    setProfiles(profilesLocal);
    loadWeatherForecasts(race, stage, profile);
  }
  function handleOnClickStages(stage, raceInput = null) {
    let raceLocal = raceInput === null ? race : raceInput;
    let profileId = null;
    if (props.raceType === 'editor')
      profileId = stage.profileCode ? stage.profileCode : null;
    else
      profileId = stage.profile === 1 ? null : stage.profile;

    console.log('Profile to be shown: ' + profileId);
    if (profileId) {
      // if not found, get it
      if (!profiles.some(p => p.profileCode && p.profileCode === profileId || p.profile && p.profile && profileId)) {
        handleBackendRequest('GET', '/profile/' + profileId, null, props.raceType === 'editor' ? { context: 'editor' } : null,
          function (profile) {
            handleProfileResponse(profile, raceLocal, stage);
          });          
      }
      else {
        // get profile from cache
        setSelectedProfile(profiles.find(p => p.profileCode && p.profileCode === profileId || p.profile && p.profile && profileId));
      }
    }
    else 
      setSelectedProfile(null);

    setSelectedStageNumber(stage.number);
    setSelectedStage(raceLocal.stages[stage.number - 1]);
  }

  function loadWeatherForecasts(race, stage, profile) {
    // skip for planned races
    if (race.status === 'Planned')
      return;
    
    // load weather forecasts for stage
    handleBackendRequest('GET', '/profile/' + stage.profile + '/weatherForecast', null, null,
      function (weatherForecastResult) {
        setWeatherForecasts(weatherForecasts.concat(weatherForecastResult.map(wf => (
          {
            ...wf,
            forecastKm: profile.sectors.findIndex(km => km.forecastId === wf.id && km.forecastType !== 'Interpolated') + 1,
            stageNumber: stage.number
          }))));
      });
  }

  function handleSetSelectedRaceEditionId(raceEditionId) {
    if (!raceEditionId) {
      setSelectedRaceEditionId(null);
    }
    else if (raceEditionResults.some(result => result.raceEditionId === raceEditionId)) {
      setSelectedRaceEditionId(raceEditionId);
    }
    else {
      handleBackendRequest('GET', '/statistics/raceEdition', null, { raceEditionId: raceEditionId },
        function (raceEditionReportsResult) {
          setRaceEditionResults(raceEditionResults.concat(raceEditionReportsResult));
          setSelectedRaceEditionId(raceEditionId);
        });
    }
  }

  function translateDegreesToDirection(degrees) {
    switch (Math.round(degrees / 22.5)) {
      case 1: return 'NNE';
      case 2: return 'NE';
      case 3: return 'ENE';
      case 4: return 'E';
      case 5: return 'ESE';
      case 6: return 'SE';
      case 7: return 'SSE';
      case 8: return 'S';
      case 9: return 'SSW';
      case 10: return 'SW';
      case 11: return 'WSW';
      case 12: return 'W';
      case 13: return 'WNW';
      case 14: return 'NW';
      case 15: return 'NNW';
      default: return 'N';
    }
  }

  function calculateStageDate(race, stage) {
    let startingDate = race.status === 'Planned' ? race.raceEditions[0].startingDate : race.startingDate;
    let firstHalfStagesBeforeStage = race.stages.filter(s => s.number < stage.number && s.stageType === 'FirstHalfStage').length;
    return moment(startingDate).add(stage.number - 1 - firstHalfStagesBeforeStage, 'd').format('dd, D-MMM');
  }

  const Line = ({ mapState: { width, height }, latLngToPixel, coordsArray, style = { stroke: 'rgb(255,0,0)', strokeWidth: 2 } }) => {
    if (coordsArray.length < 2) {
      return null
    }

    let lines = []
    let pixel = latLngToPixel(coordsArray[0])

    for (let i = 1; i < coordsArray.length; i++) {
      let pixel2 = latLngToPixel(coordsArray[i])
      lines.push(<line key={i} x1={pixel[0]} y1={pixel[1]} x2={pixel2[0]} y2={pixel2[1]} style={style} />)
      pixel = pixel2
    }

    return (
      <svg width={width} height={height} style={{ top: 0, left: 0 }}>
        {lines}
      </svg>
    )
  }

  function getProfileCenter() {
    let minLat = selectedProfile.sectors[0].latitude, maxLat = selectedProfile.sectors[0].latitude;
    let minLon = selectedProfile.sectors[0].longitude, maxLon = selectedProfile.sectors[0].longitude;
    selectedProfile.sectors.map(sector => {
      minLat = Math.min(minLat, sector.latitude);
      maxLat = Math.max(maxLat, sector.latitude);
      minLon = Math.min(minLon, sector.longitude);
      maxLon = Math.max(maxLon, sector.longitude);
    });

    return [(minLat + maxLat) / 2, (minLon + maxLon) / 2];
  }

  useEffect(() => {
    loadRace();
    if (selectedRaceEditionId) {
      handleSetSelectedRaceEditionId(selectedRaceEditionId);
    }
  }, []);
  
  function showRace(raceEditionId) {
    navigate('/race', { state: { raceEditionId: raceEditionId } });
  }

  if (race !== null && selectedStage !== null)
    return <>
      <div className="container-fluid m-0 p-0 justify-content-center">
        <div className="row d-flex p-0 m-1 justify-content-center">
          <div className="col m-1 p-1"
            style={{ maxWidth: 746, minHeight: 230, minWidth: 300 }}
          >
            <h5><u>Stage Info</u></h5>
            <div className="border border-secondary m-0 p-1"
              style={{ maxWidth: 746, minHeight: 188, maxHeight: 188, minWidth: 300, backgroundColor: 'rgba(251, 253, 255, 1)', overflow: "auto" }}
            >
              {race.status === 'Planned' || race.startingDate >= moment().format('YYYY-MM-DD') ? 
                <><b>Status:</b> {race.status === 'Planned' ? (!race.stages[selectedStageNumber - 1].profileCode ? '✴️ Planned' : '☑️ Designed') : '✅️ Published'}<br /></>
              : null }              
              {race.numberOfStages > 1 ?
                <>                
                  <b>Race:</b> {race.raceName}<br />
                  <b>Stage:</b> {selectedStage.name + ' (' + selectedStage.number + ' / ' + race.numberOfStages + ')'}<br />
                </>
                :
                <>                                  
                  <b>Race:</b> {selectedStage.name}<br />
                </>                
              }              
              <b>Category:</b> {race.category}<br />
              <b>Description:</b> {selectedStage.description}<br />
              {selectedStage.stageType !== 'FullStage' ? 
                <>
                  <b>Full/Half Stage:</b> {selectedStage.stageType}<br />
                </>
              : null }
              <b>Stage Length:</b> {selectedStage.profileCode ? selectedStage.length + 'km': 'tbd'}<br />
              <b>Stage Classification:</b> {selectedStage.stageBonificationType}<br />
            </div>
            <div className="border border-secondary m-0 p-1" style={{ maxWidth: 746, Height: 42, minWidth: 300, backgroundColor: 'rgba(251, 253, 255, 1)' }}>
              <b>Race Edition: </b>
              <ButtonGroup>
                {race.raceEditions.map(raceEdition =>
                  <Button size="sm" variant={selectedRaceEditionId === raceEdition.id ? 'primary' : 'outline-primary'}
                    disabled={race.status === 'Planned'}
                    onClick={() => {
                      handleSetSelectedRaceEditionId(raceEdition.id);
                    }}>{raceEdition.startingTime}h</Button>
                )}
              </ButtonGroup>
            </div>
          </div>
          <div className="col-12 m-1 p-1"
            style={{ maxWidth: 746, maxHeight: 240 }}
          >
            <h5><u>Stage Profile</u></h5>
            <div className="border border-secondary m-0 p-0" style={{ maxWidth: 746, maxHeight: 240, backgroundColor: 'rgba(251, 253, 255, 1)' }}>
              {selectedStage !== null && selectedStage.profile !== 1 ?
                <img style={{ maxHeight: "100%", maxWidth: "100%" }} alt="Race profile will be shown here."
                  src={config.DIR_PROFILES + selectedStage.profileCode + ".png?" + currentISODate}></img>
                : null
              }
            </div>
          </div>
        </div>
        <div className="row p-0 ml-2 justify-content-center">
          {selectedStage && selectedStage.profileCode && selectedProfile ?
            <C4FDetailedProfile key={selectedStage.profileCode} profile={selectedProfile}
              rulesetName={race.rulesetName}              
              currentSector={0}
              minuteTactStart={selectedStage.minuteTactStart}
              lastSector={selectedStage.length}
              tablePos={580} />
          : null }
          <div className="col m-1 pr-4 justify-content-center">
            <div className="row my-2 justify-content-center">
              <ButtonGroup>
                <Button variant={(tab === 'Stages') ? 'primary' : 'outline-primary'}
                  onClick={() => {
                    setTab('Stages');
                  }}>Stages</Button>
                <Button variant={(tab === 'map') ? 'primary' : 'outline-primary'} 
                  disabled={!selectedStage.profileCode || !selectedProfile}
                  onClick={() => setTab('map')}>Map</Button>
                <Button variant={(tab === 'weather') ? 'primary' : 'outline-primary'} 
                  disabled={race.status === 'Planned'} 
                  onClick={() => setTab('weather')}>Weather</Button>
                {(race.raceName.search("NM/CN") === -1) ?
                  <Button variant={(tab === 'Prizes') ? 'primary' : 'outline-primary'}
                    onClick={() => {
                      setTab('Prizes');
                    }}>Prizes</Button>
                  : ""
                }
                <Button variant={(tab === 'Previous') ? 'primary' : 'outline-primary'}
                  onClick={() => {
                    loadPreviousWinners();
                    setTab('Previous');
                  }}>History</Button>
              </ButtonGroup>
            </div>
            {(() => {
              if (tab === 'Stages') {
                return <>
                  <h5><u>List of Stages</u></h5>
                  <div className="m-0 p-0" style={{ minHeight: 100, maxHeight: 370, overflow: 'auto', backgroundColor: 'rgba(245, 250, 255, 1)' }}>
                    <C4FSimpleTable key={'stageList'}
                      highlightCriteriaKey={'number'}
                      highlightCriteriaValue={selectedStageNumber}
                      hideFilterButtons={true}
                      hideColumnVisibility={true}
                      indexColumn={true}
                      data={race.stages.map(stage => ({
                        ...stage,
                        stageDate: calculateStageDate(race, stage),
                        stageTypeCombined: ((stage.stageBonificationType === 'IndividualTimeTrial') ? 'ITT' : (stage.stageBonificationType === 'TeamTimeTrial' ? 'TTT' : stage.stageBonificationType)) + (stage.stageType !== 'FullStage' ? ' (half stage)' : ''),
                        elevationGainFormatted: stage.profileCode ? stage.elevationGain + 'm' : 'tbd',
                        lengthFormatted: stage.profileCode ? stage.length + 'km' : 'tbd',
                        minuteTactStartFormatted: stage.profileCode ? 'km' + stage.minuteTactStart : 'tbd',
                        durationFormatted: stage.profileCode ? Math.round(stage.length - stage.minuteTactStart / 2) + 'min' : 'tbd',
                      }))}
                      rowMetadata={[
                        { columnName: 'stageDate', columnDescription: 'Date' },
                        { columnName: 'name', columnDescription: 'Name', cellClickEvent: handleOnClickStages },
                        { columnName: 'stageTypeCombined', columnDescription: 'Type' },
                        { columnName: 'lengthFormatted', columnDescription: 'Length' },
                        { columnName: 'elevationGainFormatted', columnDescription: 'Elevation' },
                        { columnName: 'minuteTactStartFormatted', columnDescription: 'Min-Tact' },
                        { columnName: 'durationFormatted', columnDescription: 'Duration' }
                      ]}
                    />
                  </div>
                  <div className="row  d-flex p-0 m-1 justify-content-center">
                    <div className="col m-1 p-0">
                      <h5>
                        <u>{(race.numberOfStages > 1) ? 'Stage Report' : 'Race Report' + (selectedRaceEditionId ? ' (ID ' + selectedRaceEditionId + ')' : '')}                          
                        </u>
                        {userInformation ?
                          <Button className="mx-1" size="sm" variant={'primary'} 
                            disabled={!selectedRaceEditionId || !raceEditionResults.some(r => r.raceEditionId === selectedRaceEditionId && r.raceStillAvailable)}
                            onClick={() => showRace(selectedRaceEditionId)}>Show</Button>
                          : null }
                      </h5>
                      <div key={selectedRaceEditionId + selectedStage} className="border border-secondary" style={{ minHeight: 100, maxHeight: 290, minWidth: 250, overflow: 'auto', backgroundColor: 'rgba(251, 253, 255, 1)' }}>
                        {selectedRaceEditionId && raceEditionResults.some(r => r.raceEditionId === selectedRaceEditionId && r.stage === selectedStageNumber) ?
                          raceEditionResults.find(r => r.raceEditionId === selectedRaceEditionId && r.stage === selectedStageNumber).result.split('\n').map((line, key) => (
                            <p className="text-justify mt-0 mb-0 px-0 py-0" style={{ fontSize: "0.9em" }}>{line}</p>
                          )) :
                          (!selectedRaceEditionId ?
                            <p>Please select a Race Edition in the "Stage Info" to show stage results.</p>
                            :
                            ""
                          )
                        }
                      </div>
                    </div>
                    {race.numberOfStages > 1 ?
                      <div className="col m-1 p-0">
                        <h5><u>{'Overall Results'  + (selectedRaceEditionId ? ' (ID ' + selectedRaceEditionId + ')' : '')}</u></h5>
                        <div className="border border-secondary" style={{ minHeight: 100, maxHeight: 290, minWidth: 250, overflow: 'auto', backgroundColor: 'rgba(251, 253, 255, 1)' }}>
                          {selectedRaceEditionId && raceEditionResults.some(r => r.raceEditionId === selectedRaceEditionId && r.stage === 0 && r.result !== '') ?
                            raceEditionResults.find(r => r.raceEditionId === selectedRaceEditionId && r.stage === 0).result.split('\n').map((line, key) => (
                              <p className="text-justify mt-0 mb-0 px-0 py-0" style={{ fontSize: "0.9em" }}>{line}</p>
                            )) 
                            : 
                            (!selectedRaceEditionId ?
                              <p>Please select a Race Edition in the "Stage Info" to show stage results.</p>
                              :
                              ""
                            )}
                        </div>
                      </div>
                      : ""}
                  </div>
                  <div className="row d-flex p-0 m-1 justify-content-center">
                    <div className="col m-1 p-0">
                      <p style={{ textAlign: "center" }}><br />If something goes wrong, please report errors in the <a href={config.FORUM_BASE_URL + 'viewforum.php?f=5'} target="_blank" rel="noreferrer">Bug-Area</a> in the <a href={config.FORUM_BASE_URL} target="_blank" rel="noreferrer">Forum</a>.</p>
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                    </div>
                  </div>
                </>
              }
              if (tab === 'map' && selectedStage.profileCode && selectedProfile) {
                return <>
                  <Row className="justify-content-center" >
                    <Map center={getProfileCenter()} zoom={8} minZoom={6} maxZoom={13} width={600} height={400}>
                      <ZoomControl />
                      <Line coordsArray={selectedProfile.sectors.map(sector => ([sector.latitude, sector.longitude]))} />
                    </Map>
                  </Row>
                </>
              }
              if (tab === 'weather') {
                return <>
                  <h5><u>Weather Forecasts</u></h5>
                  <div className="m-0 p-0" style={{ minHeight: 100, maxHeight: 370, overflow: 'auto', backgroundColor: 'rgba(245, 250, 255, 1)' }}>
                    <C4FSimpleTable
                      data={weatherForecasts.map(weatherForecast => ({
                        ...weatherForecast,
                        windDirectionDegreesAndText: weatherForecast.windDirection + ' (' + translateDegreesToDirection(weatherForecast.windDirection) + ')',
                        cityCountry: weatherForecast.cityName ? weatherForecast.cityName + ' (' + weatherForecast.countryCode + ')' : weatherForecast.climateZone,
                        requestDateTrunc: weatherForecast.requestDate.split(' ')[0]
                      }))}
                      hideFilterButtons={true}
                      rowMetadata={[
                        { columnName: 'stageNumber', columnDescription: 'Stage' },
                        { columnName: 'forecastKm', columnDescription: 'km' },
                        { columnName: 'cityCountry', columnDescription: 'Location / Zone' },
                        { columnName: 'requestDateTrunc', columnDescription: 'Forecast Date' },
                        { columnName: 'temperature', columnDescription: 'Temp' },
                        { columnName: 'precipitationProbability', columnDescription: 'Rain %' },
                        { columnName: 'precipitationAmount', columnDescription: 'Rain mm' },
                        { columnName: 'windSpeed', columnDescription: 'Wind m/s' },
                        { columnName: 'windDirectionDegreesAndText', columnDescription: 'Direction' },
                        { columnName: 'cloudCover', columnDescription: 'Cloud %' }
                      ]}
                    />
                  </div>
                </>
              }
              if (tab === 'Prizes' && race !== null) {
                let raceEdition = selectedRaceEditionId ? race.raceEditions.find(re => re.id === selectedRaceEditionId) : null;

                return <C4FPrizeMoney key={'prizeMoney' + selectedRaceEditionId} raceEdition={{
                  numberOfParticipants: raceEdition && raceEdition.raceEditionStatus !== 'Inscription' ? raceEdition.numberOfParticipants : 10,
                  group: raceEdition ? raceEdition.group : 1,
                  race: {
                    category: race.category,
                    ridersPerTeam: race.ridersPerTeam,
                    rulesetName: race.rulesetName,
                    numberOfStages: race.numberOfStages
                  }                  
                }} />
              }
              if (tab === 'Previous') {
                return <div className="col" style={{ textAlign: "center" }}>
                  <Row className=" d-flex m-0 p-0">
                    <Col className="  m-0 p-0">
                      <ButtonGroup className="btn-group ml-2 mr-2">
                        <Button variant={(palmaresTypeFilterName === 'StageWin') ? 'secondary py-0' : 'outline-secondary py-0'} onClick={() => handlePalmaresTypeFilter('StageWin')}>{(race.duration > 1) ? 'Stage Wins \uD83C\uDFC6' : 'Race Wins \uD83C\uDFC6'}</Button>
                        {(race.duration > 1) ?
                          <>
                            <Button variant={(palmaresTypeFilterName === 'StageRaceWin') ? 'secondary py-0' : 'outline-secondary py-0'}
                              onClick={() => handlePalmaresTypeFilter('StageRaceWin')}>GC<img alt="GCLeader" src={getJersey('recurringEvent' in race ? race.recurringEvent : race.raceName, 'GCLeader')} style={{ maxHeight: "18px", marginBottom: 1 }} /></Button>
                            <Button variant={(palmaresTypeFilterName === 'SprintJersey') ? 'secondary py-0' : 'outline-secondary py-0'}
                              onClick={() => handlePalmaresTypeFilter('SprintJersey')}>Points<img alt="Sprint" src={getJersey('recurringEvent' in race ? race.recurringEvent : race.raceName, 'Sprint')} style={{ maxHeight: "18px", marginBottom: 1 }} /></Button>
                            <Button variant={(palmaresTypeFilterName === 'MountainJersey') ? 'secondary py-0' : 'outline-secondary py-0'}
                              onClick={() => handlePalmaresTypeFilter('MountainJersey')}>Mountain<img alt="Mountain" src={getJersey('recurringEvent' in race ? race.recurringEvent : race.raceName, 'Mountain')} style={{ maxHeight: "18px", marginBottom: 1 }} /></Button>
                            <Button variant={(palmaresTypeFilterName === 'YouthJersey') ? 'secondary py-0' : 'outline-secondary py-0'}
                              onClick={() => handlePalmaresTypeFilter('YouthJersey')}>Youth<img alt="Youth" src={getJersey('recurringEvent' in race ? race.recurringEvent : race.raceName, 'Youth')} style={{ maxHeight: "18px", marginBottom: 1 }} /></Button>
                            <Button variant={(palmaresTypeFilterName === 'TeamClassification') ? 'secondary py-0' : 'outline-secondary py-0'}
                              onClick={() => handlePalmaresTypeFilter('TeamClassification')}>Team<img alt="Team" src={getJersey('recurringEvent' in race ? race.recurringEvent : race.raceName, 'Team')} style={{ maxHeight: "18px", marginBottom: 1 }} /></Button>
                          </>
                          : ""}
                      </ButtonGroup><br /><br />
                    </Col>
                  </Row>
                  <Row className=" d-flex m-0 p-0">
                    <Col className=" m-1 p-0" style={{ minWidth: 500, maxWidth: 540, maxHeight: 200, overflow: 'auto' }}>
                      <b>Rider Ranking</b>
                      <C4FSimpleTable key={'race' + 'previousWinnersRiderCount' + palmaresTypeSorting}
                        highlightCriteriaKey={userInformation !== null ? 'teamName' : null}
                        highlightCriteriaValue={userInformation !== null ? userInformation.userName : null}
                        initialSortingColumn={race.duration > 1 ? palmaresTypeSorting : 'stages'}
                        initialSortingAscending={false}
                        indexColumn={true}
                        hideFilterButtons={true}
                        description={palmaresTypeFilter + "s per Rider"}
                        data={raceRiderPalmares.map(p => ({
                          ...p,
                          shortTeamName: (p.teamName.length > (16-Math.floor(Math.log10(raceRiderPalmares.length)))) ? (p.teamName.substr(0, (14-Math.floor(Math.log10(raceRiderPalmares.length)))) + '.') : p.teamName,
                          shortRiderName: (p.riderName.length > 16) ? ((p.riderName.split(" ")[1].length > 13)  ? (p.riderName.split(" ")[0].substr(0, 1) + '. ' + p.riderName.split(" ")[1].substr(0, 12) + '.') : (p.riderName.split(" ")[0].substr(0, 1) + '. ' + p.riderName.split(" ")[1])) : p.riderName
                        }))}
                        rowMetadata={race.duration > 1 ?
                          [
                            { columnName: 'shortRiderName', columnDescription: 'Rider', cellClickEvent: showRiderInfo },
                            { columnName: 'shortTeamName', columnDescription: 'Team', cellClickEvent: showTeamInfo },
                            { columnName: 'stages', columnDescription: '\uD83C\uDFC6' },
                            { columnName: 'tours', columnDescription: 'GCs', columnHeader: <><img alt="GCLeader" title="Stage Race Wins" src={getJersey('recurringEvent' in race ? race.recurringEvent : race.raceName, 'GCLeader')} style={{ maxHeight: "18px", marginBottom: 1 }} /></> },
                            { columnName: 'sprintJerseys', columnDescription: 'Points', columnHeader: <><img alt="Sprint" title="Sprint Jerseys" src={getJersey('recurringEvent' in race ? race.recurringEvent : race.raceName, 'Sprint')} style={{ maxHeight: "18px", marginBottom: 1 }} /></> },
                            { columnName: 'mountainJerseys', columnDescription: 'Mountain', columnHeader: <><img alt="Sprint" title="Mountain Jerseys" src={getJersey('recurringEvent' in race ? race.recurringEvent : race.raceName, 'Mountain')} style={{ maxHeight: "18px", marginBottom: 1 }} /></> },
                            { columnName: 'youthJerseys', columnDescription: 'Youth', columnHeader: <><img alt="Sprint" title="Youth Jerseys" src={getJersey('recurringEvent' in race ? race.recurringEvent : race.raceName, 'Youth')} style={{ maxHeight: "18px", marginBottom: 1 }} /></> }
                          ]
                          :
                          [
                            { columnName: 'riderName', columnDescription: 'Rider', cellClickEvent: showRiderInfo },
                            { columnName: 'teamName', columnDescription: 'Team', cellClickEvent: showTeamInfo },
                            { columnName: 'stages', columnDescription: '\uD83C\uDFC6' }
                          ]
                        }
                      />
                    </Col>
                    <Col className=" m-1 p-0" style={{ minWidth: 300, maxWidth: 420, maxHeight: 200, overflow: 'auto' }}>
                      <b>Team Ranking</b>
                      <C4FSimpleTable key={'race' + 'previousWinnersTeamCount' + palmaresTypeSorting}
                        highlightCriteriaKey={userInformation !== null ? 'teamName' : null}
                        highlightCriteriaValue={userInformation !== null ? userInformation.userName : null}
                        initialSortingColumn={race.duration > 1 ? palmaresTypeSorting : 'stages'}
                        initialSortingAscending={false}
                        indexColumn={true}
                        hideFilterButtons={true}
                        data={raceTeamPalmares.map(p => ({
                          ...p,
                          shortTeamName: (p.teamName.length > (16-Math.floor(Math.log10(raceTeamPalmares.length)))) ? (p.teamName.substr(0, (14-Math.floor(Math.log10(raceTeamPalmares.length)))) + '.') : p.teamName
                        }))}
                        rowMetadata={race.duration > 1 ?
                          [
                            { columnName: 'shortTeamName', columnDescription: 'Team', cellClickEvent: showTeamInfo },
                            { columnName: 'stages', columnDescription: '\uD83C\uDFC6' },
                            { columnName: 'tours', columnDescription: 'GCs', columnHeader: <><img alt="GCLeader" title="Stage Race Wins" src={getJersey('recurringEvent' in race ? race.recurringEvent : race.raceName, 'GCLeader')} style={{ maxHeight: "18px", marginBottom: 1 }} /></> },
                            { columnName: 'sprintJerseys', columnDescription: 'Points', columnHeader: <><img alt="Sprint" title="Sprint Jerseys" src={getJersey('recurringEvent' in race ? race.recurringEvent : race.raceName, 'Sprint')} style={{ maxHeight: "18px", marginBottom: 1 }} /></> },
                            { columnName: 'mountainJerseys', columnDescription: 'Mountain', columnHeader: <><img alt="Sprint" title="Mountain Jerseys" src={getJersey('recurringEvent' in race ? race.recurringEvent : race.raceName, 'Mountain')} style={{ maxHeight: "18px", marginBottom: 1 }} /></> },
                            { columnName: 'youthJerseys', columnDescription: 'Youth', columnHeader: <><img alt="Sprint" title="Youth Jerseys" src={getJersey('recurringEvent' in race ? race.recurringEvent : race.raceName, 'Youth')} style={{ maxHeight: "18px", marginBottom: 1 }} /></> },
                            { columnName: 'teamClassifications', columnDescription: 'Team', columnHeader: <><img alt="Team" title="Team Classification" src={getJersey('recurringEvent' in race ? race.recurringEvent : race.raceName, 'Team')} style={{ maxHeight: "18px", marginBottom: 1 }} /></> }
                          ]
                          :
                          [
                            { columnName: 'teamName', columnDescription: 'Team', cellClickEvent: showTeamInfo },
                            { columnName: 'stages', columnDescription: '\uD83C\uDFC6' }
                          ]
                        }
                      />
                    </Col>
                  </Row>
                  <div className="row d-flex m-0 p-0">
                    <div className="col m-0 p-0">
                      <br />
                      <b>All Entries</b>
                      <C4FSimpleTable key={'race' + 'racePalmares' + palmaresTypeFilterName}
                        highlightCriteriaKey={userInformation !== null ? 'teamName' : null}
                        highlightCriteriaValue={userInformation !== null ? userInformation.userName : null}
                        initialSortingColumn={'date'}
                        initialSortingAscending={false}
                        hideColumnVisibility={true}
                        maxHeight={300}
                        filters={palmaresTypeFilter}
                        data={racePalmares
                          .map(p => ({
                            ...p,
                            palmaresDate: moment(p.date).format('D-MMM-YYYY'),
                            shortRaceName: ((p.raceName.length > 40) ? (p.raceName.substr(0, 37) + '...') : p.raceName)
                          }))
                        }
                        rowMetadata={[
                          { columnName: 'palmaresDate', columnDescription: 'Date' },
                          { columnName: 'type', columnDescription: 'Type' },
                          { columnName: 'riderName', columnDescription: 'Rider', cellClickEvent: showRiderInfo },
                          { columnName: 'teamName', columnDescription: 'Team', cellClickEvent: showTeamInfo },
                          { columnName: 'shortRaceName', columnDescription: 'Race' },
                          { columnName: 'category', columnDescription: 'Cat.' }

                        ]
                        }
                      />
                    </div>
                  </div>
                  <div className="row d-flex m-0 p-0">
                    <div className="col m-0 p-0">
                      <br />
                      <p><b>Note:</b> You can report missing previous editions <a href={config.FORUM_BASE_URL + 'viewtopic.php?f=66&t=9370'} target="_blank" rel="noreferrer">in this Thread</a> in the <a href={config.FORUM_BASE_URL} target="_blank" rel="noreferrer">Forum</a>.</p>
                    </div>
                  </div>
                </div>
              }
            })()}
          </div>
        </div>
      </div>
    </>;
  else return null;
}
export default CalendarSingleRace;
